import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { IClientsSocis, IClientsSocisResponse } from '../clientssocis.interfaces';
import { ClientsSocisService } from '../../services/clients_socis/clientsSocis.service';

@Component({
  selector: 'mcrit-gestio-manage-clientssocis',
  templateUrl: './manage-clientssocis.component.html',
  styleUrls: ['./manage-clientssocis.component.scss'],
  providers: [ClientsSocisService]
})
export class ManageClientsSocisComponent implements OnInit, OnDestroy {
  private routeParamsSubs: any;
  private clientSociModel: IClientsSocis = {
      'id': 'NEW',
      'nom': null,
      'tipus': null,
      'telefon': null,
      'adreca': null,
      'client': true,
      'soci': true,
      'localitzacio': null,
      'descripcio': null,
      'comentari': null,
      'web': null,
      'mail': null,
      'country': null,
      'cif': null
  };
  private id: string;
  public error: string = '';
  public showAsyncProgress: boolean = false;
  public editClientSociData: IClientsSocis;
  public possibleTipus: Array<string> = [];

  public addOrUpdate(): void {
    if(this.editClientSociData.nom == "" || !this.editClientSociData.nom){alert("Cal omplir el camp Nom/Sigles.");return;}
    if(this.editClientSociData.tipus == "" || !this.editClientSociData.tipus){alert("Cal omplir el camp tipus d'empresa.");return;}
    this.showAsyncProgress = true;
    if (this.editClientSociData.id === 'NEW') {
      this.clientsSocisService.createClientSoci(this.editClientSociData)
        .subscribe(newClientSoci => {console.log("S'ha creat l'element");this.router.navigate(['clientssocislist']);});
    } else {
      this.clientsSocisService.updateClientSoci(<number> this.editClientSociData.id, this.editClientSociData)
        .subscribe(updatedClientSoci => {console.log("S'han desat les dades");this.router.navigate(['clientssocislist']);});
    }
  }

  public deleteClientSoci(IdclientSociToDelete: number): void {
    if(confirm("Confirma l'esborrat del client/soci")){
      this.showAsyncProgress = true;
      this.clientsSocisService.deleteClientSoci(<number> IdclientSociToDelete)
        .subscribe(deletedClientSoci => {
          this.showAsyncProgress = false;
          if(deletedClientSoci.err){this.error = deletedClientSoci.err;return;}
          console.log("S'ha esborrat l'element");
          this.router.navigate(['clientssocislist']);});
    }
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, private clientsSocisService: ClientsSocisService, protected route: ActivatedRoute, protected router: Router){ }

  ngOnInit() {
    this.routeParamsSubs = this.route.params.subscribe(params => {
      this.id = params['id'];
      if(this.id === 'NEW'){this.editClientSociData = this.clientSociModel;return;}
      this.clientsSocisService.getClientSoci(this.id)
        .subscribe(
           data=> {
            this.editClientSociData = data.rows[0];
          },
          error => console.log(error)
        );
    });

    this.clientsSocisService.getClientSociTipus()
      .subscribe(
        data=> {
          this.possibleTipus = data.filter(elem => elem.nom != '').map(item => item.nom);
        },
        error => console.log(error)
      );
  }

  ngOnDestroy() { this.routeParamsSubs.unsubscribe(); }
}
